import { useQuery } from '@tanstack/react-query';

import { fetchCategoryPage, FetchCategoryPageResponse } from '../../api/entryPage/fetchCategoryPage';
import { GlobalReactQueryOptions } from '../../config';
import { AgeCategory } from '../../../models/AgeCategory';
import { CategoryPageType } from '../../../models/CategoryPage';
import { LoanFormat } from '../../../models/LoanFormat';
import { UseQueryResult } from '../../api/query-types';

type UseCategoryPageQuery = UseQueryResult<'data', FetchCategoryPageResponse>;

type UseCategoryPageOptions = {
    readonly loanFormat?: LoanFormat;
    readonly ageCategory?: AgeCategory;
    readonly shopLanguage?: string;
};

const emptyCategoryPage = {
    buckets: [],
    topBuckets: []
};

export const useCategoryPageQuery = (
    categoryPage: CategoryPageType,
    { loanFormat, ageCategory, shopLanguage }: UseCategoryPageOptions = {}
): UseCategoryPageQuery => {
    const params = {
        loanFormat,
        ageCategory,
        shopLanguage
    };
    const { data, ...result } = useQuery(
        ['categoryPage', categoryPage, params],
        () => fetchCategoryPage(categoryPage, params),
        { ...GlobalReactQueryOptions }
    );

    return {
        ...result,
        data: data ?? emptyCategoryPage
    };
};
